import { render, staticRenderFns } from "./DecoArranger.vue?vue&type=template&id=38b9d4e9&"
import script from "./DecoArranger.vue?vue&type=script&lang=ts&"
export * from "./DecoArranger.vue?vue&type=script&lang=ts&"
import style0 from "./DecoArranger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports